const CAMERA_PERMISSION_TIMEOUT_MS = 15000;

const parseMessageData = (data) => {
  if (typeof data !== 'string') return data;
  try {
    return JSON.parse(data);
  } catch {
    return data;
  }
};

export default function requestNativeCameraPermission({
  timeoutMs = CAMERA_PERMISSION_TIMEOUT_MS,
} = {}) {
  return new Promise((resolve) => {
    if (!window.ReactNativeWebView) {
      resolve(null);
      return;
    }

    let settled = false;
    const finish = (value) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timer);
      window.removeEventListener('message', handleMessage);
      document.removeEventListener('message', handleMessage);
      resolve(value);
    };

    const handleMessage = (event) => {
      const message = parseMessageData(event?.data);
      if (message?.type !== 'camera-permission') return;
      finish(Boolean(message?.data?.granted));
    };

    const timer = window.setTimeout(() => finish(null), timeoutMs);
    window.addEventListener('message', handleMessage);
    document.addEventListener('message', handleMessage);
    window.ReactNativeWebView.postMessage(
      JSON.stringify({ data: 'camera-permission' })
    );
  });
}
